import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Button from "wonderbly-components/lib/Button";
import Icon from "wonderbly-components/lib/Icon";
import { Col } from "src/client/js/view/components/Grid";
import PaymentIcons from "../PaymentIcons";
import PayPal from "./PayPal";
import Accordion from "../Accordion";
import AccordionItem from "../Accordion/AccordionItem";
import DiscountForm from "../CartSummary/DiscountForm";
import RichText from "../Prismic/RichText";
import MentionMe from "../MentionMe";

import "./Checkout.scss";

const isMethodSupported = (id, paymentMethods = []) =>
  paymentMethods.some((method) => method.id === id);

const CheckoutButtons = (props) => {
  return props.sortOrder.map((type) => {
    switch (type) {
      case "standard":
        return (
          <Button
            className="checkout-button"
            onClick={props.onHandleCheckout}
            href={props.checkoutUrl}
            fullWidth
          >
            <Icon icon="lock" />
            {` ${props.checkoutCta}`}
          </Button>
        );
      case "paypal":
        if (
          props.hidePaypalButton ||
          !isMethodSupported("paypal_checkout", props.paymentMethods)
        ) {
          return null;
        }

        return (
          <div className="quick-checkout">
            <PayPal
              paymentMethods={props.paymentMethods}
              href={props.paypalUrl}
            />
          </div>
        );
      default:
        return null;
    }
  });
};

const Checkout = (props) => {
  return (
    <React.Fragment>
      <div className="cart-summary-checkout" data-testid="cart-summary">
        {!props.hidePaymentIcons && (
          <Col className="cart-summary-payment-icons">
            <div className="cart-summary-payment-icons__label">
              {props.paymentMethodsLabel || "We accept:"}
            </div>
            <PaymentIcons exclusionList={props.exclusionList} />
          </Col>
        )}
        <div
          className={cx("cart-summary-checkout__ctas", {
            "cart-summary-checkout__ctas--order-reverse":
              props.positionDiscountFormFirst,
          })}
        >
          <div className="padded-wrapper">
            <CheckoutButtons
              sortOrder={props.sortOrder}
              onHandleCheckout={props.handleCheckout}
              checkoutUrl={props.checkoutUrl}
              checkoutCta={props.checkoutCta}
              hidePaypalButton={props.hidePaypalButton}
              paymentMethods={props.paymentMethods}
              paypalUrl={props.paypalUrl}
            />
          </div>
          <Accordion>
            <AccordionItem
              isExpanded={props.isAccordionExpanded}
              label={
                <RichText
                  fields={props.description}
                  className="discount-form-description"
                />
              }
            >
              <DiscountForm
                description={props.description}
                cta={props.cta}
                placeholder={props.placeholder}
              />
            </AccordionItem>
          </Accordion>
        </div>
        <MentionMe
          type="refereefind"
          situation="checkout"
          country={props.country}
          implementation="link"
          id="mmWrapper"
        />
      </div>
    </React.Fragment>
  );
};

CheckoutButtons.propTypes = {
  sortOrder: PropTypes.arrayOf(PropTypes.string).isRequired,
  checkoutUrl: PropTypes.string.isRequired,
  checkoutCta: PropTypes.string.isRequired,
  paymentMethods: PropTypes.array.isRequired,
  handleCheckout: PropTypes.func.isRequired,
  paypalUrl: PropTypes.string.isRequired,
  hidePaypalButton: PropTypes.bool,
};

Checkout.propTypes = {
  ...CheckoutButtons.propTypes,
  quickCheckoutLabel: PropTypes.string,
  description: PropTypes.array.isRequired,
  cta: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  country: PropTypes.object,
  exclusionList: PropTypes.arrayOf(PropTypes.string),
  hidePaymentIcons: PropTypes.bool,
  isAccordionExpanded: PropTypes.bool,
  paymentMethodsLabel: PropTypes.string,
  positionDiscountFormFirst: PropTypes.bool,
};

export default Checkout;
